<template>
  <v-app>
    <div>
      <mcity-toolbar
        :fullname="fullname"
        :username="username"
        :presentation-text="presentationText"
        :isUserAdmin="isUserAdmin"
        :title="title"
      >
        <template slot="buttons">
          <v-btn
            v-if="isUserAdmin"
            flat
            :to="{name: 'New'}"
            data-cy="new-dataset-btn">
            New Dataset
          </v-btn>
          <v-btn 
            v-if="showEditButton"
            flat
            @click="isEditMode ? saveDataset() : setEditMode()"
            target="_blank"
            :disabled="disableEditButton"
            data-cy="edit-dataset-btn">
            {{ this.isEditMode ? 'Save' : 'Edit' }}
          </v-btn>
          <v-btn 
            v-if="showDeleteButton"
            flat
            @click="deleteDataset()"
            target="_blank"
            data-cy="dataset-delete-btn">
            Delete
          </v-btn>
        </template>
      </mcity-toolbar>
    </div>

    <v-content>
      <v-container fluid>
        <v-alert
          type="error"
          v-model="showRequestFailed"
          dismissible
        >
          Request Failed - 
          If problem persists, please email mcity-engineering@umich.edu :
          {{ errorText }}
        </v-alert>
        <router-view/>
        <router-view name="auth"/>
        <auth-refresh
          v-if="getShowIframe"
        ></auth-refresh>
      </v-container>
    </v-content>

    <v-footer dark color="primary" fixed app>
      <span>&copy; 2024-2028 The Regents of the University of Michigan</span>
      <v-spacer></v-spacer>
      <span class="mr-1">{{ username }} : {{ today }}</span>
    </v-footer>
  </v-app>
</template>

<script>
import { mapMutations, mapGetters, mapActions } from 'vuex'
import authRefresh from '@mcity/mcity-vue-auth/src/components/RefreshAuthiFrame.vue'
import McityToolbar from '@mcity/mcity-vue-shared/components/McityToolbarVuetify1.5.vue'
import { dom } from '@fortawesome/fontawesome-svg-core'

export default {
  name: 'App',
  components: {
    authRefresh,
    McityToolbar
  },
  methods: {
    ...mapActions([
      'deleteDatasetAction',
      'saveDatasetAction'
    ]),
    ...mapMutations([
      'setEdit',
      'setView',
      'logError'
    ]),
    setEditMode () {
      this.$router.push(`/dataset/${this.getDatasetKey}/edit`)
    },
    setViewMode () {
      this.$router.push(`/dataset/${this.getDatasetKey}`)
    },
    deleteDataset () {
      confirm(`Are you sure you want to delete dataset: ${this.getDatasetKey}?`) &&
      this.deleteDatasetAction()
        .then(response => this.$router.push('/'))
    },
    saveDataset () {
      const payload = {
        data: { ...this.getDatasetEdits }
      }
      this.saveDatasetAction(payload)
        .then(() => this.$router.push(`/dataset/${this.getDatasetKey}`))
    }
  },
  watch: {
    getErrors (val) {
      this.showRequestFailed = true
      this.errorText = val[val.length - 1]
    }
  },
  computed: {
    ...mapGetters([
      'getDatasetKey',
      'getPresentMode',
      'getUser',
      'isUserPI',
      'isUserAdmin',
      'getTopFieldsInvalid',
      'getErrors',
      'getShowIframe',
      'isUserLoading',
      'getDatasetEdits'
    ]),
    presentationText () {
      return this.getPresentMode ? 'Private' : 'Presentation'
    },
    today () {
      let date = new Date()
      return date.toISOString().slice(0, 10)
    },
    username () {
      return this.getUser && this.getUser.username ? this.getUser.username : 'placeholder@email.com'
    },
    fullname () {
      const user = this.getUser
      return user && user.first_name && user.last_name
        ? `${user.first_name} ${user.last_name}` : `Firstname Lastname`
    },
    disableEditButton () {
      return this.getTopFieldsInvalid && this.isEditMode
    },
    showEditButton () {
      return this.$route.path.includes('/dataset') && (this.isUserAdmin || this.isUserPI)
    },
    showDeleteButton () {
      return this.$route.path.includes('/dataset') && this.isUserAdmin
    },
    isEditMode () {
      return this.$route.name  === 'DatasetEdit'
    }
  },
  data () {
    return {
      avatarMenu: false,
      clipped: false,
      showRequestFailed: false,
      errorText: null,
      iframeURL: '/refresh.html',
      title: 'Data Garage'
    }
  },
  mounted () {
    dom.watch()
  }
}
</script>

<style lang="scss">
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  background-color: #f2f2f2;
}
#nav {
  padding: 30px;
  a {
    font-weight: bold;
    color: #2c3e50;
    &.router-link-exact-active {
      color: #42b983;
    }
  }
}

.whiteM {
  fill:#fff;
  stroke: #fff;
}
.maizeM {
  fill:#f5c400;
}
.logo {
  display: block;
  width: 160px;
}
.small, small {
  font-size: 80%;
  font-weight: 400;
}
.presentation {
  font-size: 120% !important;
}
.date {
  position: absolute;
  bottom: 6px;
  right: 16px;
}
.link {
  display: block;
}
</style>
